import { Table, TableBody, TableHeader } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { NoResults } from '@library/components/NoResults';
import { PaginationButtons } from '@library/components/buttons/PaginationButtons';
import { USER_ROLES_HEADER } from '@bo-constants/userRoles';
import type { UserMenuEvent } from '@library/types/user';
import { UserRolesContext } from '@bo-hooks/user/useAdminUsersContext';
import { UserRolesRow } from '@library/components/table/rows/UserRolesRow';
import { useContext } from 'react';

export const UserRoles = () => {
  const {
    filters,
    isUserRolesLoading,
    modals,
    onSort,
    onSelectedUserId,
    sort,
    userData
  } = useContext(UserRolesContext);
  const { currentPage, onCurrentPageChange } = filters;
  const { onDeactivateUserModalOpen, onEditUserDrawerOpen } = modals;

  const handleUserMenuEvent = ({ userId, eventType }: UserMenuEvent) => {
    if (eventType === 'edit') {
      onEditUserDrawerOpen(true);
    } else {
      onDeactivateUserModalOpen(true);
    }

    onSelectedUserId(userId);
  };

  if (isUserRolesLoading) {
    return <Loading loadingMessage="Loading User Roles" />;
  }

  if (!userData?.users?.length) {
    return (
      <NoResults
        className="m-0"
        label="Use the search bar to search by Name, Email, or Role"
      />
    );
  }

  return (
    <Table>
      <div className="flex flex-col overflow-x-auto" data-testid="UserRoles">
        <TableHeader headers={USER_ROLES_HEADER} sort={sort} onSort={onSort} />
        <TableBody>
          {userData?.users.map((user) => (
            <UserRolesRow
              key={user.id}
              user={user}
              onUserMenuEvent={handleUserMenuEvent}
            />
          ))}
        </TableBody>
      </div>

      <PaginationButtons
        currentPage={currentPage}
        handlePageChange={onCurrentPageChange}
        totalPages={userData?.paginationInfo.total_pages ?? 0}
      />
    </Table>
  );
};
